export const CONTENT_TYPES = {
  SPECIALS: 'Especiales',
  BLOG: 'Blog',
  DESTINATION: 'Destino',
  TRAVELS: 'Tipos de viaje',
  PAGE: 'Pagina',
  EVENTS: 'Eventos',
  PACKAGES: 'Paquetes',
  EXPERIENCES: 'Experiencias',
};

export const MODULE_TYPES = {
  ACTIVITIES: 'Actividades / Traslados / Otros',
  DESTINATIONS_ACTIVITIES: 'Actividades por destino',
  BREADCRUMBS: 'Breadcrumbs',
  SEARCH_BOX: 'Buscador',
  CONTENTS: 'Contenido',
  CONTENTS_SEARCH: 'Contenido por parametros',
  DESTINATIONS: 'Destinos',
  PAYMENT_METHODS: 'Formas de pago',
  HOTELS: 'Hoteles',
  IMAGES: 'Imagenes',
  ABOUT: 'Institucional',
  PACKAGES_LIST: 'Listado de paquetes',
  PACKAGES: 'Paquetes',
  SOCIAL: 'Seguinos',
  SUBSCRIBE_NEWSLETTER: 'Suscripcion newsletter',
  CARDS: 'Tarjetas contenido',
  TEXT: 'Texto',
  CONTACT: 'Contacto',
};

export const LANGUAGES = {
  es: 'Español',
  en: 'Ingles',
  pt: 'Portugues',
  fr: 'Frances',
  cn: 'Chino',
  it: 'Italiano',
};

export const NATIONALITIES = [
  { id: 133, name: "Afganistan", code: "AF" },
  { id: 50, name: "Alaska", code: "ZZ" },
  { id: 206, name: "Albania", code: "AL" },
  { id: 63, name: "Alemania", code: "DE" },
  { id: 147, name: "Angola", code: "AO" },
  { id: 105, name: "Anguila", code: "AI" },
  { id: 219, name: "Antartica", code: "A2" },
  { id: 218, name: "Antartida", code: "A1" },
  { id: 189, name: "Antigua y Barbuda", code: "AG" },
  { id: 70, name: "Antillas Hollandesas", code: "AN" },
  { id: 132, name: "Arabia Saudita", code: "SA" },
  { id: 29, name: "Argelia", code: "DZ" },
  { id: 41, name: "Argentina", code: "AR" },
  { id: 122, name: "Armenia", code: "AM" },
  { id: 31, name: "Aruba", code: "AW" },
  { id: 11, name: "Australia", code: "AU" },
  { id: 217, name: "Australia y Pacifico", code: "APF" },
  { id: 119, name: "Austria", code: "AT" },
  { id: 42, name: "Azerbaijan", code: "AZ" },
  { id: 65, name: "Bahamas", code: "BS" },
  { id: 222, name: "Bahamas ", code: "" },
  { id: 155, name: "Bahrain", code: "BH" },
  { id: 97, name: "Bangladesh", code: "BD" },
  { id: 74, name: "Barbados", code: "BB" },
  { id: 25, name: "Belgica", code: "BE" },
  { id: 60, name: "Belice", code: "BZ" },
  { id: 93, name: "Benin", code: "BJ" },
  { id: 64, name: "Bermuda", code: "BM" },
  { id: 177, name: "Bhutan", code: "BT" },
  { id: 161, name: "Bielorrusia", code: "BY" },
  { id: 89, name: "Bolivia", code: "BO" },
  { id: 46, name: "Bosnia-Herzegovina", code: "BA" },
  { id: 114, name: "Botswana", code: "BW" },
  { id: 27, name: "Brasil", code: "BR" },
  { id: 199, name: "Bulgaria", code: "BG" },
  { id: 174, name: "Burkina Faso", code: "BF" },
  { id: 77, name: "Burundi", code: "BI" },
  { id: 129, name: "Cabo Verde", code: "CV" },
  { id: 178, name: "Camboya", code: "KH" },
  { id: 211, name: "Camerun", code: "CM" },
  { id: 78, name: "Canada", code: "CA" },
  { id: 226, name: "Catar", code: "" },
  { id: 168, name: "Chad", code: "TD" },
  { id: 22, name: "Chile", code: "CL" },
  { id: 57, name: "China", code: "CN" },
  { id: 106, name: "Chipre", code: "CY" },
  { id: 48, name: "Colombia", code: "CO" },
  { id: 166, name: "Comoras", code: "KM" },
  { id: 73, name: "Congo", code: "CG" },
  { id: 186, name: "Corea del Norte", code: "KP" },
  { id: 198, name: "Corea del Sur", code: "KR" },
  { id: 192, name: "Costa Rica", code: "CR" },
  { id: 102, name: "Croacia", code: "HR" },
  { id: 79, name: "Cuba", code: "CU" },
  { id: 1, name: "Dinamarca", code: "DK" },
  { id: 188, name: "Dominica", code: "DM" },
  { id: 216, name: "Dubai y Emiratos", code: "DEA" },
  { id: 94, name: "Ecuador", code: "EC" },
  { id: 6, name: "Egipto", code: "EG" },
  { id: 194, name: "El Salvador", code: "SV" },
  { id: 5, name: "Emiratos Arabes Unidos", code: "AE" },
  { id: 33, name: "Eritrea", code: "ER" },
  { id: 225, name: "Escocia", code: "" },
  { id: 72, name: "Eslovaquia", code: "SK" },
  { id: 145, name: "Eslovenia", code: "SI" },
  { id: 16, name: "España", code: "ES" },
  { id: 18, name: "Estados Unidos", code: "US" },
  { id: 201, name: "Estonia", code: "EE" },
  { id: 10, name: "Ethiopia", code: "ET" },
  { id: 196, name: "Fiji", code: "FJ" },
  { id: 156, name: "Filipinas", code: "PH" },
  { id: 126, name: "Finlandia", code: "FI" },
  { id: 39, name: "Francia", code: "FR" },
  { id: 143, name: "Gabon", code: "GA" },
  { id: 47, name: "Gambia", code: "GM" },
  { id: 54, name: "Georgia", code: "GE" },
  { id: 9, name: "Ghana", code: "GH" },
  { id: 116, name: "Gibraltar", code: "GI" },
  { id: 37, name: "Grecia", code: "GR" },
  { id: 120, name: "Grenada", code: "GD" },
  { id: 172, name: "Groenlandia", code: "GL" },
  { id: 53, name: "Guadalupe", code: "GP" },
  { id: 12, name: "Guam", code: "GU" },
  { id: 121, name: "Guatemala", code: "GT" },
  { id: 92, name: "Guinea", code: "GN" },
  { id: 152, name: "Guinea Ecuatorial", code: "GQ" },
  { id: 68, name: "Guinea-Bissau", code: "GW" },
  { id: 85, name: "Guyana Francesa", code: "GF" },
  { id: 183, name: "Haiti", code: "HT" },
  { id: 20, name: "Holanda", code: "NL" },
  { id: 204, name: "Honduras", code: "HN" },
  { id: 76, name: "Hungria", code: "HU" },
  { id: 13, name: "India", code: "IN" },
  { id: 131, name: "Indonesia", code: "ID" },
  { id: 4, name: "Inglaterra", code: "GB" },
  { id: 205, name: "Iran", code: "IR" },
  { id: 40, name: "Iraq", code: "IQ" },
  { id: 101, name: "Irlanda", code: "IE" },
  { id: 115, name: "Isla Asencion", code: "AC" },
  { id: 187, name: "Islandia", code: "IS" },
  { id: 117, name: "Islas Caiman", code: "KY" },
  { id: 14, name: "Islas Cook", code: "CK" },
  { id: 110, name: "Islas Faroe", code: "FO" },
  { id: 220, name: "Islas Maldivas ", code: "8K" },
  { id: 185, name: "Islas Malvinas - Argentina", code: "FK" },
  { id: 191, name: "Islas Marianas del Norte", code: "MP" },
  { id: 151, name: "Islas Marshall", code: "MH" },
  { id: 228, name: "Islas Marshall", code: "IM" },
  { id: 127, name: "Islas Solomon", code: "SB" },
  { id: 55, name: "Islas Virgenes (Britanicas)", code: "VG" },
  { id: 200, name: "Islas Virgenes (EE.UU.)", code: "VI" },
  { id: 56, name: "Israel", code: "IL" },
  { id: 21, name: "Italia", code: "IT" },
  { id: 139, name: "Jamaica", code: "JM" },
  { id: 123, name: "Japon", code: "JP" },
  { id: 19, name: "Jordania", code: "JO" },
  { id: 34, name: "Kazakhstan", code: "KZ" },
  { id: 167, name: "Kenya", code: "KE" },
  { id: 202, name: "Kiribati", code: "KI" },
  { id: 141, name: "Kuwait", code: "KW" },
  { id: 67, name: "Kyrguistan", code: "KG" },
  { id: 209, name: "Laos", code: "LA" },
  { id: 96, name: "Latvia", code: "LV" },
  { id: 159, name: "Lesoto", code: "LS" },
  { id: 58, name: "Libano", code: "LB" },
  { id: 163, name: "Liberia", code: "LR" },
  { id: 61, name: "Libya", code: "LY" },
  { id: 49, name: "Lithuania", code: "LT" },
  { id: 150, name: "Luxemburgo", code: "LU" },
  { id: 173, name: "Macedonia", code: "MK" },
  { id: 24, name: "Madagascar", code: "MG" },
  { id: 17, name: "Malasia", code: "MY" },
  { id: 144, name: "Malaui", code: "MW" },
  { id: 153, name: "Maldivas", code: "MV" },
  { id: 43, name: "Mali", code: "ML" },
  { id: 148, name: "Malta", code: "MT" },
  { id: 83, name: "Marruecos", code: "MA" },
  { id: 111, name: "Martinica", code: "MQ" },
  { id: 180, name: "Mauricio", code: "MU" },
  { id: 170, name: "Mauritania", code: "MR" },
  { id: 104, name: "Mayotte", code: "YT" },
  { id: 214, name: "Mediterraneo", code: "MED" },
  { id: 8, name: "México", code: "MX" },
  { id: 87, name: "Micronesia", code: "FM" },
  { id: 86, name: "Moldavia", code: "MD" },
  { id: 164, name: "Monaco", code: "MC" },
  { id: 207, name: "Mongolia", code: "MN" },
  { id: 179, name: "Montenegro", code: "ME" },
  { id: 165, name: "Montserrat", code: "MS" },
  { id: 158, name: "Mozambique", code: "MZ" },
  { id: 160, name: "Myanmar", code: "MM" },
  { id: 210, name: "Namibia", code: "NA" },
  { id: 135, name: "Nepal", code: "NP" },
  { id: 154, name: "Nicaragua", code: "NI" },
  { id: 169, name: "Niger", code: "NE" },
  { id: 7, name: "Nigeria", code: "NG" },
  { id: 62, name: "Noruega", code: "NO" },
  { id: 171, name: "Nueva Caledonia", code: "NC" },
  { id: 38, name: "Nueva Zelanda", code: "NZ" },
  { id: 137, name: "Oman", code: "OM" },
  { id: 130, name: "Pakistan", code: "PK" },
  { id: 69, name: "Panama", code: "PA" },
  { id: 3, name: "Papua Nueva Guinea", code: "PG" },
  { id: 35, name: "Paraguay", code: "PY" },
  { id: 28, name: "Perú", code: "PE" },
  { id: 71, name: "Polinesia Francesa", code: "PF" },
  { id: 208, name: "Polonia", code: "PL" },
  { id: 109, name: "Portugal", code: "PT" },
  { id: 224, name: "Principado de Andorra", code: "" },
  { id: 193, name: "Puerto Rico", code: "PR" },
  { id: 100, name: "Qatar", code: "QA" },
  { id: 45, name: "Republica Centroafricana", code: "CF" },
  { id: 184, name: "Republica Checa", code: "CZ" },
  { id: 140, name: "Republica Democratica del Congo", code: "CD" },
  { id: 142, name: "Republica Dominicana", code: "DO" },
  { id: 190, name: "Reunion", code: "RE" },
  { id: 215, name: "Riviera Mexicana", code: "RMX" },
  { id: 134, name: "Ruanda", code: "RW" },
  { id: 75, name: "Rumania", code: "RO" },
  { id: 2, name: "Rusia", code: "RU" },
  { id: 80, name: "Saint Vincent y Granadinas", code: "VC" },
  { id: 26, name: "Samoa", code: "WS" },
  { id: 175, name: "Samoa Americana", code: "AS" },
  { id: 84, name: "Santa Lucia", code: "LC" },
  { id: 81, name: "Senegal", code: "SN" },
  { id: 59, name: "Serbia", code: "CS" },
  { id: 66, name: "Seychelles", code: "SC" },
  { id: 112, name: "Sierra Leona", code: "SL" },
  { id: 197, name: "Singapur", code: "SG" },
  { id: 221, name: "Sint Maarten", code: "" },
  { id: 162, name: "Somalia", code: "SO" },
  { id: 90, name: "Sri Lanka", code: "LK" },
  { id: 52, name: "St Kitts and Nevis", code: "KN" },
  { id: 88, name: "Sudafrica", code: "ZA" },
  { id: 136, name: "Sudan", code: "SD" },
  { id: 107, name: "Suecia", code: "SE" },
  { id: 51, name: "Suiza", code: "CH" },
  { id: 176, name: "Surinam", code: "SR" },
  { id: 157, name: "Swaziland", code: "SZ" },
  { id: 15, name: "Syria", code: "SY" },
  { id: 44, name: "Tailandia", code: "TH" },
  { id: 128, name: "Taiwan", code: "TW" },
  { id: 103, name: "Tajikistan", code: "TJ" },
  { id: 95, name: "Tanzania", code: "TZ" },
  { id: 227, name: "Tibet", code: "" },
  { id: 36, name: "Timor Oriental", code: "TP" },
  { id: 146, name: "Togo", code: "TG" },
  { id: 108, name: "Tonga", code: "TO" },
  { id: 181, name: "Trinidad y Tobago", code: "TT" },
  { id: 98, name: "Tunez", code: "TN" },
  { id: 223, name: "Túnez", code: "" },
  { id: 32, name: "Turkmenistan", code: "TM" },
  { id: 118, name: "Turks and Caicos", code: "TC" },
  { id: 23, name: "Turquia", code: "TR" },
  { id: 113, name: "Tuvalu", code: "TV" },
  { id: 138, name: "Ucrania", code: "UA" },
  { id: 30, name: "Uganda", code: "UG" },
  { id: 91, name: "Uruguay", code: "UY" },
  { id: 203, name: "Uzbekistan", code: "UZ" },
  { id: 182, name: "Vanuatu", code: "VU" },
  { id: 82, name: "Venezuela", code: "VE" },
  { id: 124, name: "Vietnam", code: "VN" },
  { id: 195, name: "Yemen", code: "YD" },
  { id: 99, name: "Yibuti", code: "DJ" },
  { id: 149, name: "Zambia", code: "ZM" },
  { id: 125, name: "Zimbabwe", code: "ZW" }
];



// WEBPACK FOOTER //
// ./src/globals.ts